import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ParticipantView from './components/ParticipantView/ParticipantView';
import PresenterView from './components/PresenterView/PresenterView';
import PrepareView from './components/PrepareView/PrepareView';
import { FirebaseProvider } from './hooks/useFirebase';
import './App.css';

function App() {
  return (
    <FirebaseProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/participate" element={<ParticipantView />} />
            <Route path="/present" element={<PresenterView />} />
            <Route path="/prepare" element={<PrepareView />} />
            <Route path="/" element={<Navigate to="/participate" replace />} />
          </Routes>
        </div>
      </Router>
    </FirebaseProvider>
  );
}

export default App;
